// extracted by mini-css-extract-plugin
export default {"container":"ModifierComposante_container__R55Nj","btn_stylo":"ModifierComposante_btn_stylo__VWQft"};